import { render, staticRenderFns } from "./ApprovalConfigPagination.vue?vue&type=template&id=250c1f70&scoped=true"
import script from "./ApprovalConfigPagination.vue?vue&type=script&lang=js"
export * from "./ApprovalConfigPagination.vue?vue&type=script&lang=js"
import style0 from "./ApprovalConfigPagination.vue?vue&type=style&index=0&id=250c1f70&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "250c1f70",
  null
  
)

export default component.exports